import { render, staticRenderFns } from "./supplier-orders-confirm.vue?vue&type=template&id=54291522&scoped=true"
import script from "./supplier-orders-confirm.vue?vue&type=script&lang=js"
export * from "./supplier-orders-confirm.vue?vue&type=script&lang=js"
import style0 from "./supplier-orders-confirm.vue?vue&type=style&index=0&id=54291522&prod&lang=scss&scoped=true"
import style1 from "./supplier-orders-confirm.vue?vue&type=style&index=1&id=54291522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54291522",
  null
  
)

export default component.exports